/* Blair TLV — header glass overlay v6 (2026-05-30)
   Changes from v5:
   - Marquee (announcement bar) moved OUT of the fixed wrapper into the top
     of <body>. It now sits in normal flow above the header and scrolls away
     with the page (conventional layout: marquee → header → content).
   - Wrapper holds only the header. Switched from fixed to sticky so the
     header is below the marquee at rest, then sticks to top: 0 after the
     marquee scrolls out.
   - Hide-on-scroll-down / show-on-scroll-up still works via transform.
*/
(function () {
  if (window.Shopify && window.Shopify.designMode) return;

  var THRESHOLD_OPACITY = 24;
  var THRESHOLD_HIDE = 160;
  var lastY = 0;
  var ticking = false;
  var scrolledFlag = null;
  var hiddenFlag = null;
  var wrapper = null;

  function setupLayout() {
    var sections = document.querySelectorAll('.shopify-section-group-header-group');
    if (!sections.length) return null;
    var existing = document.querySelector('.blair-header-fixed');
    if (existing) return existing;

    var headerSection = null;
    var announcementSection = null;
    sections.forEach(function (s) {
      if (s.classList.contains('section-header')) headerSection = s;
      else announcementSection = s;
    });

    var anchor = sections[0];
    var parent = anchor.parentNode;

    // Build the sticky wrapper at the original header position, containing only the header
    var w = document.createElement('div');
    w.className = 'blair-header-fixed';
    parent.insertBefore(w, anchor.nextSibling || null);
    if (headerSection) w.appendChild(headerSection);

    // Place the announcement bar in normal flow immediately AFTER the header wrapper
    if (announcementSection) {
      w.parentNode.insertBefore(announcementSection, w.nextSibling);
    }

    return w;
  }

  function measureHeader() {
    if (!wrapper) return;
    var h = wrapper.getBoundingClientRect().height;
    if (h > 0) {
      document.documentElement.style.setProperty('--blair-header-h', h + 'px');
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var y = window.scrollY || window.pageYOffset || 0;
      // Founder 2026-06-24: never hide the header while the nav drawer is open.
      var menuOpen = document.querySelector('.section-header.menu-open') || document.querySelector('#Details-menu-drawer-container[open]');
      if (menuOpen) {
        if (wrapper && hiddenFlag !== false) { wrapper.classList.remove('is-hidden'); hiddenFlag = false; }
        lastY = y; ticking = false; return;
      }
      var past = y > THRESHOLD_OPACITY;

      if (past !== scrolledFlag) {
        document.body.classList.toggle('scrolled-past-header', past);
        scrolledFlag = past;
      }

      if (wrapper && y > THRESHOLD_HIDE) {
        var goingDown = y > lastY + 2;
        var goingUp = y < lastY - 2;
        if (goingDown && hiddenFlag !== true) {
          wrapper.classList.add('is-hidden');
          hiddenFlag = true;
        } else if (goingUp && hiddenFlag !== false) {
          wrapper.classList.remove('is-hidden');
          hiddenFlag = false;
        }
      } else if (wrapper && hiddenFlag !== false) {
        wrapper.classList.remove('is-hidden');
        hiddenFlag = false;
      }

      lastY = y;
      ticking = false;
    });
  }

  function init() {
    wrapper = setupLayout();
    measureHeader();
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', measureHeader, { passive: true });
    setTimeout(measureHeader, 400);
    setTimeout(measureHeader, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Instagram section heading bidi fix — the Spotlight Instafeed app renders
     its heading with leading !!! (source: "!!!עקבו..."). In RTL bidi this
     puts the !!! at the visual RIGHT, but in Hebrew convention exclamation
     marks belong at the END of the sentence (visual LEFT in RTL). Move them
     to the end of the string so bidi renders them on the left correctly. */
  function fixInstafeedHeadingBidi() {
    if (document.documentElement.dir !== 'rtl') return;
    var feed = document.getElementById('insta-feed');
    if (!feed) return;
    var heading = feed.parentElement && feed.parentElement.querySelector('h1, h2, h3, h4');
    if (!heading) return;
    var text = heading.textContent;
    if (!text) return;
    // Match leading run of !? marks, move to end
    var m = text.match(/^([!?]+)\s*(.+?)\s*$/);
    if (m) {
      heading.textContent = m[2] + m[1];
    }
  }

  function pollInstafeed() {
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (document.querySelector('#insta-feed h1, #insta-feed ~ * h2, #insta-feed h2, #shopify-section-template--18072529305828__17459611929b25bfa3 h2')) {
        fixInstafeedHeadingBidi();
      }
      if (tries > 20) clearInterval(iv);
    }, 500);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pollInstafeed);
  } else {
    pollInstafeed();
  }
})();
